// The product's name as both browser apps show it. StaffSmith is the working
// name and may change (functional design v0.3, Oct 31 decisions): a rename is
// this one line. NHMiller Enterprises, the operator company, isn't the product.
export const PRODUCT_NAME = "StaffSmith";
